/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ table: NonNullable<unknown> }} Agent_Builder_Result_Action_Table_UnavailableInputs */



/**
* | output |
* | --- |
* | "{table} (no longer in this dataset)" |
*
* @param {Agent_Builder_Result_Action_Table_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_result_action_table_unavailable = /** @type {((inputs: Agent_Builder_Result_Action_Table_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Result_Action_Table_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.table} (nicht mehr in diesem Datensatz)`)
	return /** @type {LocalizedString} */ (`${i?.table} (no longer in this dataset)`)
});